import React from "react";
import { Modal, ModalHeader, ModalBody } from "reactstrap";

class ModalWindow extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      modal: true,
    };
  }

  toggleModal = () => {
    this.setState((prevState) => ({ modal: !prevState.modal }));
    if (this.props.toggleModal) {
      this.props.toggleModal();
    }
  };

  render() {
    const { className, headerClassName, title, children } = this.props;
    const { modal } = this.state;

    return (
      <Modal
        isOpen={modal}
        toggle={this.toggleModal}
        className={className}
        backdrop={true}
        size="lg"
        style={{ marginTop: "5rem" }}
      >
        {title && (
          <ModalHeader
            toggle={this.toggleModal}
            className={headerClassName}
            style={{ justifyContent: "center" }}
          >
            {title}
          </ModalHeader>
        )}
        <ModalBody>{children}</ModalBody>
      </Modal>
    );
  }
}

export default ModalWindow;
